import type { ReactElement } from 'react';
import { useState } from 'react';

import { ForgotUsernamePasswordChoice } from 'module/auth/forgotUser/components/ForgotUsernamePasswordChoice';
import { PatientForgotUserIdView } from 'module/auth/forgotUser/components/PatientForgotUserIdView';
import 'module/auth/forgotUser/confirm.page.scss';

export interface ForgotUserScreenProps {
    onChoosePassword: () => void;
    onBackToLogin: () => void;
    choiceClassName: string;
    patientForgotUserIdClassName: string;
}

enum ForgotUserView {
    Choice,
    PatientForgotUserId,
}

export const ForgotUserScreen = ({
    onChoosePassword,
    onBackToLogin,
    choiceClassName,
    patientForgotUserIdClassName,
}: ForgotUserScreenProps): ReactElement => {
    const [view, setView] = useState<ForgotUserView>(ForgotUserView.Choice);

    if (view === ForgotUserView.PatientForgotUserId) {
        return <PatientForgotUserIdView onBackToLogin={onBackToLogin} className={patientForgotUserIdClassName} />;
    }

    return (
        <ForgotUsernamePasswordChoice
            onChoosePassword={onChoosePassword}
            onChooseUsername={(): void => setView(ForgotUserView.PatientForgotUserId)}
            onBackToLogin={onBackToLogin}
            className={choiceClassName}
        />
    );
};
